export default "__VITE_ASSET__7d801c44__"